var app = angular.module("leonardo");

var WorkFlowInstanceList = function ($scope, $state, $http, $q, $controller, WorkFlowInstanceService, ConfigThemeService,
                                     DynamicFormRestService, FilterService, AccountUserService, TaskService, ngDialog) {
  $scope.workflows = [];
  $scope.workflows_account = [];
  $scope.tab = 'total';
  $scope.totalWorkflowProgress = 0;
  $scope.workflowProgress = {};
  $scope.by_unit = $state.current.by_unit;


  $scope.changeProgress = function(tab) {
    $scope.tab = tab;
    if ($scope.tab === 'total') {
      $scope.totalWorkflowProgress = $scope.workflowProgress.progress ? $scope.workflowProgress.progress : 0;
    }
    else {
      $scope.totalWorkflowProgress = $scope.workflowProgress.avg? $scope.workflowProgress.avg : 0;
    }
  };

  $scope.getProgress = function(filters) {
    WorkFlowInstanceService.getProgress(filters).then(function(data) {
      $scope.workflowProgress = data.total;
      $scope.changeProgress($scope.tab);
    });
  };

  $scope.getEntitiesPromise = function (options) {
    var defer = $q.defer();
    options['by_unit'] = $scope.by_unit;
    if (FilterService.getFilter('account_reports')) {
      options['account'] = FilterService.getFilter('account_reports');
    }
    if (FilterService.getFilter('property_reports')) {
      options['property'] = FilterService.getFilter('property_reports');
    }
    if (FilterService.getFilter('group_reports')) {
      options['group'] = FilterService.getFilter('group_reports');
    }
    if (FilterService.getFilter('portfolio_reports')) {
      options['portfolio'] = FilterService.getFilter('portfolio_reports');
    }
    if (FilterService.getFilter('search')) {
      options['search'] = FilterService.getFilter('search');
    }
    if (FilterService.getFilter('completed_from_date')) {
      options['completed_from_date'] = FilterService.getFilter('completed_from_date');
    }
    if (FilterService.getFilter('completed_to_date')) {
      options['completed_to_date'] = FilterService.getFilter('completed_to_date');
    }
    if (FilterService.getFilter('started_from_date')) {
      options['started_from_date'] = FilterService.getFilter('started_from_date');
    }
    if (FilterService.getFilter('started_to_date')) {
      options['started_to_date'] = FilterService.getFilter('started_to_date');
    }
    if (FilterService.getFilter('status')) {
      options['status'] = FilterService.getFilter('status');
    }
    if (FilterService.getFilter('managed_by_reports')) {
      options['managed_by'] = FilterService.getFilter('managed_by_reports');
    }
    if (FilterService.getFilter('is_unit_turn')) {
      options['is_unit_turn'] = FilterService.getFilter('is_unit_turn');
    }
    if (FilterService.getFilter('unit_turn_type')) {
      options['unit_turn_type'] = FilterService.getFilter('unit_turn_type');
    }
    if (!options['ordering']) {
      options['ordering'] = $scope.by_unit ? 'unit__building,unit__number,unit__name' : '-date_of_turn';
    }
    options['with_building']=true
    $scope.getProgress(options);
    WorkFlowInstanceService.getlist(options).then(function (list) {
      $scope.workflows = list.results ? list.results : list;
      $scope.count = list.meta.count;
      $scope.validateForbiddenMessages($scope.workflows);
      $scope.groupForAccount($scope.workflows);
      if ($scope.workflows.length === 0) {
        ngDialog.open({ template: 'views/templates/dialog/no-results.html'});
      }
      defer.resolve($scope.workflows);
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  $scope.groupForAccount = function (elements) {
    $scope.workflows_account = [];
    angular.forEach(elements, function (element) {
      if ($scope.getIndex(element.account) < 0) {
        $scope.workflows_account.push({
          id: element.account,
          workflows: []
        });
      }
      $scope.workflows_account[$scope.getIndex(element.account)].workflows.push(element);
    });
  };

  $scope.validateForbiddenMessages = function(workflows) {
    angular.forEach(workflows, function (workflow) {
      angular.forEach(workflow.active_templates, function (template) {
        if (template.forbidden) {
          workflow.templates_forbidden = true;
        }
      });
    });
  };

  $scope.getIndex = function (id) {
    var index = -1;
    angular.forEach($scope.workflows_account, function (value, key) {
      if (value.id === id) index = key;
    });
    return index;
  };

  $scope.getOptions = function() {
    if ( $scope.totalWorkflowProgress === 0 ) {
      return {color: ConfigThemeService.getColor('tertiaryColor', 0.2)};
    }
    else {
      return {color: ConfigThemeService.config.theme_config.successColor};
    }
  };

  $controller('TableFilterController', { $scope: $scope });

  $scope.$on('workflow-instance:removed', function () {
    $scope.loadPage($scope.page);
  });

  $scope.$on('workflow-instance:updated', function () {
    $scope.loadPage($scope.page);
  });

  $scope.loadPage($scope.page);

};

app.controller('WorkFlowInstanceList', ['$scope', '$state', '$http', '$q', '$controller', 'WorkFlowInstanceService',
  'ConfigThemeService', 'DynamicFormRestService', 'FilterService', 'AccountUserService', 'TaskService', 'ngDialog',
  WorkFlowInstanceList
]);